import styled from "styled-components";

const Ticket = () => <TicketWrapper>Ticket</TicketWrapper>;

export default Ticket;

const TicketWrapper = styled.div`
  align-items: center;
  display: flex;
  min-height: 100vh;
  position: relative;
  flex-direction: column;
  width: 100%;
`;
